import dayjs from 'dayjs'
import { computed, watch, ref } from 'vue'
import { useStore } from 'vuex'
export default function useTime () {
  const store = useStore()
  const year = computed(() =>
    Number(
      (store.state.yearCycles[store.state.activeYearIndex] || [])[0]
        ?.displayName || dayjs().year()
    )
  )
  const theLastDayOfSelectedYear = computed(() => dayjs().year(year.value).endOf('year'))
  const theFridayOfTheWeekOfSelectedYear = computed(() => theLastDayOfSelectedYear.value.day(5))
  const lastFriday = computed(() => {
    return theLastDayOfSelectedYear.value.isBefore(theFridayOfTheWeekOfSelectedYear.value) ? theFridayOfTheWeekOfSelectedYear.value.subtract(7, 'day') : theFridayOfTheWeekOfSelectedYear.value
  })
  const thisFriday = dayjs().day() > 5 ? dayjs().day(5).add('day', 7) : dayjs().day(5)

  const selectedWeek = ref(thisFriday)

  watch(lastFriday, val => {
    selectedWeek.value = lastFriday.value.isAfter(thisFriday.value) ? thisFriday : lastFriday.value
  })

  return {
    selectedWeek
  }
}
